import { FC, ReactNode } from "react";
import { Tabs } from "@mui/material";
import { TabList } from "./styles";

export type TPageTab = {
  id: number;
  label: ReactNode;
  url?: string;
};

export const PageTabs: FC<{
  tabs: TPageTab[];
  value?: number;
  onChange: (
    event: React.SyntheticEvent,
    newValue: number,
    url?: string
  ) => void;
}> = ({ tabs, value, onChange }) => {
  return (
    <Tabs
      value={value}
      onChange={(event, newValue) => {
        const url = tabs.find((t) => t.id === newValue)?.url;
        onChange(event, newValue, url);
      }}
      TabIndicatorProps={{ style: { display: "none" } }}
    >
      {tabs.map(({ id, label }) => (
        <TabList
          disableRipple
          key={id}
          value={id}
          active={id === value}
          label={label}
        />
      ))}
    </Tabs>
  );
};
